import { Backdrop, Container, Input, Paper } from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser,safeRequestParam } from 'src/utils/Common';
import { getTasksRequest } from '../../store/actions/taskActions';
import { text } from "../../modules/languages/index";
import BultenDetay from './BulletinDetail';
import Header from 'src/components/Header';
import Alert from '@material-ui/lab/Alert';
import ConcealableContainer from 'src/components/ConcealableContainer';
import logger from 'src/utils/logger';


const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  BultenDetay: {
    marginTop: theme.spacing(1)
  },
  searchB: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconB: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputB: {
    flexGrow: 1
  },
  searchButtonB: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));



const Bulten = () => {
  const classes = useStyles();
  const [BultenData, setBultenData] = useState([])
  const SessionUser = getUser();
  const [Loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('0');

  const BultenIcerikAra = () => {
    setLoading(true);
    axios.get('/GetArtemisBulten/' + SessionUser.ServiceShopId + '/' + SessionUser.UserId + '/' + (safeRequestParam(filter.trim()) || 'a')).then((response) => {
      const Deger = response.data;
      setBultenData(Deger);
      setLoading(false);
    }).catch(error => {
      setLoading(false);
      logger.error("Hata detayı:", error.message);
    });
  };


  return (
    <Page className={classes.root} title={text("Artemis_Atanan_isler")}>
      <Container maxWidth="lg">
        <Header />
        <ConcealableContainer show={true}>
          <Alert severity="warning">{"Bu sayfada görüntüleme yapılmaktadır!.."}</Alert>
        </ConcealableContainer>
        {
          Loading ?
            <Backdrop className={classes.backdrop} open={Loading}>
              <CircularProgress color="inherit" />
            </Backdrop>
            : <div></div>
        }
        <Paper
          className={classes.searchB}
          elevation={1}>
          <Input
            className={classes.searchInputB}
            disableUnderline
            onChange={event => { setFilter(event.target.value) }}
            placeholder="Bülten içerik arama yap!..."
          />
          <SearchIcon onClick={BultenIcerikAra} className={classes.searchIconB} />
        </Paper>
        <BultenDetay className={classes.BultenDetay} BultenDetay={BultenData} loading={Loading} setLoading={setLoading} />
      </Container>
    </Page>
  );
}


export default connect(
  state => ({ tasks: state.tasks1 })
  ,
  {
    getTasksRequest
  }
)(Bulten);
